import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { useSurveyQueryKey } from './useSurveyQueryKey'

export const useInvalidateSurveyQuery = () => {
  const queryClient = useQueryClient()
  const queryKey = useSurveyQueryKey()

  return React.useCallback(
    () => queryClient.invalidateQueries({ queryKey }),
    [queryKey, queryClient],
  )
}
